document.addEventListener('DOMContentLoaded', () => {

    const elements = document.querySelectorAll('.bubbles blockquote, .attenuation .attenuation-container > div');

    const single = document.querySelector('.attenuation .attenuation-container');

    const gaugeAnimation = document.querySelector('.gauge-animation');

    if (!elements.length) return;

    let lastScrollY = window.scrollY;
    let scrollDirection = 'down';
    let ticking = false;

    window.addEventListener('scroll', () => {

        const currentScrollY = window.scrollY;

        scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';

        lastScrollY = currentScrollY;

        if (!ticking) {

            window.requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });

            ticking = true;

        }

    });


    function handleScroll() {

        const isDesktop = window.innerWidth >= 992

        elements.forEach(el => {

            const check = elements.length > 1 && !isDesktop

            const rect = scrollDirection === 'up' && check ? elements[1].getBoundingClientRect() : el.getBoundingClientRect();

            const main = el.closest('.bubbles')

            const elementHeight = rect.height;

            const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);

            const menuHeight = document.querySelector('#header-main-menu').offsetHeight

            const isFullyVisible = (visibleHeight + menuHeight) >= elementHeight;

            const svg = el.querySelector('svg');

            const span = el.querySelector('span');

            const div = el.querySelector('div');

            let transform

            let opacity

            if (el.classList.contains('opacity-quote')) {

                let percentage = svg ? (el === elements[0] && el.closest('section.bubbles') ? getVisibilityPercentage(main) : getVisibilityPercentage(el)) : getVisibilityPercentage(el);

                console.log(percentage)

                percentage = percentage * 2

                transform = 0;

                opacity = 1;

                if (scrollDirection === 'down') {

                    transform = Math.max(0, 100 - percentage);

                    opacity = percentage / 100;

                    if (transform <= 0) {
                        el.dataset.frozen = 'true';
                    }

                }

                if (scrollDirection === 'up') {

                    const hasPassed = check && single ? 
                    (single.getBoundingClientRect().top - single.getBoundingClientRect().height + window.innerHeight + el.getBoundingClientRect().height - menuHeight) >= 0
                    : (rect.top + rect.height) >= window.innerHeight

                    

                    if (hasPassed) {
                        delete el.dataset.frozen;
                        const distanceFromBottom = Math.abs(window.innerHeight - rect.bottom);
                        const fadeProgress = Math.min(1, Math.max(0, distanceFromBottom / 100));
                        transform = Math.max(-100, fadeProgress * 100);
                        opacity = 1 - fadeProgress;
                    }

                }

                // Apply styles (unless frozen)
                if (el.dataset.frozen === 'true') {
                    transform = 0;
                    opacity = 1;
                }

                if( gaugeAnimation && gaugeAnimation.classList.contains('in-view') ) {
                    opacity = 0
                    transform = 100;
                }

                if (el.closest('.attenuation-parent')) {

                    const info = el.closest('.attenuation-parent').querySelector('.information')

                    if (info) {
                        info.style.opacity = opacity.toFixed(2);
                        info.style.transform = `translateY(${transform.toFixed(1)}%)`;
                    } else {
                        el.closest('.attenuation-parent').querySelector('.details').style.opacity = opacity.toFixed(2);
                    }


                } else {
                    svg.style.strokeOpacity = opacity.toFixed(2);
                    span.style.opacity = opacity.toFixed(2);
                    div.style.transform = `translateY(${transform.toFixed(1)}%)`;
                }

            }

            if (scrollDirection === 'down' && isFullyVisible && !el.classList.contains('opacity-quote')) {
                el.classList.add('opacity-quote');
            }

        })

    }

    function init() {

        const scrollPosition = window.scrollY || window.pageYOffset;

        elements.forEach(el => {

            const rect = el.getBoundingClientRect();

            const elementTop = rect.top + scrollPosition;

            if (scrollPosition > elementTop || isScrolledIntoView(el)) {
                el.classList.add('opacity-quote');
            }

        });

    }

    init()

});

function isScrolledIntoView(element) {
    const rect = element.getBoundingClientRect();
    return rect.top <= window.innerHeight && rect.bottom >= 0;
}

function isElementPassed10PercentView(el) {

    const rect = el.getBoundingClientRect();

    const elementHeight = rect.height;

    const viewHeight = window.innerHeight;

    const triggerPoint = viewHeight - elementHeight * 1.25;

    return rect.top <= triggerPoint;
}



function getVisibilityPercentage(el) {

    const menuHeight = document.querySelector('#header-main-menu').offsetHeight

    const rect = el.getBoundingClientRect();

    const windowHeight = (window.innerHeight || document.documentElement.clientHeight) - menuHeight;

    const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    const percentageVisible = Math.max(0, Math.min(visibleHeight / rect.height, 1));

    return percentageVisible * 100;
}
